import { Box } from "@chakra-ui/react";
import useFiltro from "infra/helpers/useFiltro";
import { useHistory } from "react-router-dom";
import useClienteListagemColumns from "./components/useClienteListagemColumns";
import PageHeader from "components/Page/PageHeader";
import HeaderTable from "components/Page/HeaderTable";
import { useBreadcrumb } from "features/breadcrumbs";
import NewTable from "components/NewTable";
import { useClientes } from "core/features/clientes-tenant/hooks";
import Container from "components/Container";
import { TabMenuOptions } from "core/features/clientes-tenant/data/TabsClientes";
import { TenantPaginateResponse } from "core/features/tenants/typings/tenant";

function ListagemClientes() {
  const history = useHistory();

  const { filtro, setFiltro, onChangeFiltro } = useFiltro();
  const { data, isLoading, isFetching } = useClientes({
    ...filtro,
  });

  const columns = useClienteListagemColumns();

  useBreadcrumb([{ name: "Clientes - Tenants" }]);

  return (
    <Container>
      <PageHeader
        title="Clientes - Tenants"
        titleButton="Adicionar novo cliente"
        onClick={() => history.push("/clientes/criar")}
      />

      <Box zIndex="1" pos="relative" mt="-10px">
        <NewTable<TenantPaginateResponse>
          title={() => (
            <HeaderTable
              value={filtro.search as any}
              onSearch={(q?: string) =>
                setFiltro((prev: any) => ({
                  ...prev,
                  search: q,
                  page: 1,
                }))
              }
            />
          )}
          loading={isLoading || isFetching}
          columns={columns}
          dataSource={data?.items ?? []}
          actions={TabMenuOptions.map((option) => ({
            title: option.label,
            onClick: (v) => {
              history.push(`/clientes/${v.id}?opcao=${option.route}`);
            },
          }))}
          customPagination={{
            currentPage: data?.meta.currentPage ?? 0,
            itemsPerPage: data?.meta.itemsPerPage ?? 0,
            totalItems: data?.meta.totalItems ?? 0,
            onChangePage: (page: number) => {
              onChangeFiltro("page", page);
            },
          }}
        />
      </Box>
    </Container>
  );
}

export default ListagemClientes;
